import React from 'react';

/**
 * Renders an <iframe> embed string inside a responsive 16:9 container.
 * Strips any width/height attrs from the iframe and stretches it to 100%.
 */
const VideoEmbed = ({ html, className = '' }) => {
  if (!html) return null;

  // Strip width/height attributes from the iframe so CSS controls sizing
  const cleaned = html
    .replace(/\swidth="[^"]*"/gi, '')
    .replace(/\sheight="[^"]*"/gi, '')
    .replace(/\sstyle="[^"]*"/gi, '');

  return (
    <div
      className={`relative w-full overflow-hidden rounded-md bg-black ${className}`}
      style={{ paddingBottom: '56.25%' }}
    >
      <div
        className="absolute inset-0 [&_iframe]:w-full [&_iframe]:h-full [&_iframe]:absolute [&_iframe]:inset-0"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: cleaned }}
      />
    </div>
  );
};

export default VideoEmbed;
